export default __webpack_public_path__ + "ui/assets/img/info-20-success.svg";